import type { BatchPlan } from '../../types';

export interface BatchManagementQueryState {
  batchIds: number[];
  templateIds: number[];
  teamCodes: string[];
  statuses: BatchPlan['plan_status'][];
  view: 'list' | 'gantt';
}

const readNumberList = (params: URLSearchParams, key: string): number[] => (
  (params.get(key) ?? '')
    .split(',')
    .map(Number)
    .filter((value) => Number.isInteger(value) && value > 0)
);

const readStringList = (params: URLSearchParams, key: string): string[] => (
  (params.get(key) ?? '')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean)
);

export function readBatchManagementQueryState(search: string): BatchManagementQueryState {
  const params = new URLSearchParams(search);
  const explicitView = params.get('batch_view');
  const statuses = readStringList(params, 'batch_statuses')
    .filter((value): value is BatchPlan['plan_status'] => value === 'DRAFT' || value === 'ACTIVATED');
  return {
    batchIds: readNumberList(params, 'batch_ids'),
    templateIds: readNumberList(params, 'template_ids'),
    teamCodes: readStringList(params, 'team_codes'),
    statuses,
    view: explicitView === 'gantt'
      ? 'gantt'
      : explicitView === 'list'
        ? 'list'
        : params.has('gantt_from') || params.has('gantt_to')
          ? 'gantt'
          : 'list',
  };
}

const setList = (params: URLSearchParams, key: string, values: Array<string | number>) => {
  if (values.length > 0) params.set(key, values.join(','));
  else params.delete(key);
};

export function writeBatchManagementQueryState(
  search: string,
  state: BatchManagementQueryState,
): string {
  const params = new URLSearchParams(search);
  setList(params, 'batch_ids', state.batchIds);
  setList(params, 'template_ids', state.templateIds);
  setList(params, 'team_codes', state.teamCodes);
  setList(params, 'batch_statuses', state.statuses);
  params.set('batch_view', state.view);
  const next = params.toString();
  return next ? `?${next}` : '';
}
